import { Person } from '../../../interfaces/person';

function findPersonInListFromId(persons: Person[], personId: number | string | undefined | null): Person | undefined {
  return persons.find((person: Person) => person.id === personId);
}

export default findPersonInListFromId;
